import { Box } from '@mui/material'
import { H_REFERENCIAL_LEXICONS } from 'account/constants/AccessRulesConstants'
import FixedSlideNav from 'components/navbar/FixedSlideNav'
import { PATH_REFERENCIAL_RPQS_LINK } from 'home/constants/RouteConstants'
import BoundaryError from 'log/components/BoundaryError'
import React, { useEffect, useMemo } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { Outlet, useParams } from 'react-router-dom'
import ReferencialAction from 'referencial/action/ReferencialAction'
import { REFERENCIAL_TYPE_NAME } from 'referencial/constants/ReferencialConstants'
import i18n from 'simple-react-i18n'
import { componentHasHabilitations } from 'utils/HabilitationUtil'

const LexiconRouterApp = ({ rpqs }) => {
    const dispatch = useDispatch()
    const { code, field } = useParams()

    const navLinks = useMemo(() => {
        if (rpqs) {
            return [{
                icons: 'dashboard',
                name: i18n.dashboard,
                href: `${PATH_REFERENCIAL_RPQS_LINK}lexicon/${code}/dashboard`,
                habilitation: H_REFERENCIAL_LEXICONS,
            }].filter(l => componentHasHabilitations(l.habilitation))
        }
        return [{
            icons: 'dashboard',
            name: i18n.dashboard,
            href: `/referencial/${REFERENCIAL_TYPE_NAME.lexicon}/${field}/${code}/dashboard`,
            habilitation: H_REFERENCIAL_LEXICONS,
        }].filter(l => componentHasHabilitations(l.habilitation))
    }, [code, field, rpqs])

    useEffect(() => {
        dispatch(ReferencialAction.fetchSandreCodes())
        dispatch(ReferencialAction.fetchReferencialSandreCodes())
    }, [dispatch])

    return (
        <Box>
            <FixedSlideNav links={navLinks} />
            <Box className='content-page fullscreen' padding={1}>
                <BoundaryError>
                    <Outlet />
                </BoundaryError>
            </Box>
        </Box>
    )
}

LexiconRouterApp.propTypes = {
    rpqs: PropTypes.bool,
}

export default LexiconRouterApp